var App = App || {};



(function (ns, Utility, $) {
    var solrUrl = '/solr/SolrAutoSuggest';
    var siteRootUrl = window.location.protocol + '//' + $('#hfSiteURL').val(); // This variable should replace baseURL below.
    var minCharsRequiredForAutoSuggest = $('.hfSolrAutoSuggestMinimumCharactersLength').val();
    var learningText = 'Learning';
    var journalsText = 'Journals';
    var autoSuggestFields;

    // ACS-897: ARIA 1.2 combobox helpers for screen reader accessibility
    var LIVE_REGION_ID = 'scm-search-live-region';

    function createLiveRegion() {
        if (document.getElementById(LIVE_REGION_ID)) {
            return;
        }
        var liveRegion = document.createElement('div');
        liveRegion.id = LIVE_REGION_ID;
        liveRegion.setAttribute('role', 'status');
        liveRegion.setAttribute('aria-live', 'polite');
        liveRegion.setAttribute('aria-atomic', 'true');
        liveRegion.className = 'screenreader-text';
        document.body.appendChild(liveRegion);
    }

    function setAriaAttributes(inputEl, resultsEl) {
        if (!inputEl || !resultsEl) {
            return;
        }
        if (!resultsEl.id) {
            // aria-controls needs a real IDREF, so fall back to the data attribute the widget was wired with.
            var fallbackId = resultsEl.getAttribute('data-autosuggest-id');
            if (!fallbackId) {
                return;
            }
            resultsEl.id = fallbackId;
        }
        inputEl.setAttribute('role', 'combobox');
        inputEl.setAttribute('aria-expanded', 'false');
        inputEl.setAttribute('aria-autocomplete', 'list');
        inputEl.setAttribute('aria-controls', resultsEl.id);
        clearActiveDescendant(inputEl);
        resultsEl.setAttribute('role', 'listbox');
        resultsEl.setAttribute('aria-label', 'Search suggestions');
    }

    // "No option is active" is expressed by removing the attribute; an empty IDREF is an invalid reference.
    function clearActiveDescendant(inputEl) {
        inputEl.removeAttribute('aria-activedescendant');
    }

    function setActiveDescendant(inputEl, activeOptId) {
        if (activeOptId) {
            inputEl.setAttribute('aria-activedescendant', activeOptId);
        } else {
            clearActiveDescendant(inputEl);
        }
    }

    function updateAriaSelected(resultsEl, activeOptId) {
        var allOptions = resultsEl.querySelectorAll('[role="option"]');
        for (var k = 0; k < allOptions.length; k++) {
            allOptions[k].setAttribute('aria-selected', allOptions[k].id === activeOptId ? 'true' : 'false');
        }
    }

    function bind(scope, fn) {
        return function () {
            fn.apply(scope, arguments);
        };
    }

    // Auto Complete Class
    function AutoCompleteWidget(searchInputControlId, searchInputHintControlId, autoCompleteResultsControlId, isMicrosite, siteFilterDropDownSelectID) {
        if (typeof searchInputControlId === 'string') {
            this.searchInputControlId = document.querySelector("[data-autosuggest-id='" + searchInputControlId + "']");
        } else {
            this.searchInputControlId = searchInputControlId;
        }
        if (typeof searchInputHintControlId === 'string') {
            this.searchInputHintControlId = document.querySelector("[data-autosuggest-id='" + searchInputHintControlId + "']");
        } else {
            this.searchInputHintControlId = searchInputHintControlId;
        }
        if (typeof autoCompleteResultsControlId === 'string') {
            this.autoCompleteResultsControlId = document.querySelector("[data-autosuggest-id='" + autoCompleteResultsControlId + "']");
        } else {
            this.autoCompleteResultsControlId = autoCompleteResultsControlId;
        }

        this.isMicrosite = isMicrosite;

        if (siteFilterDropDownSelectID !== null) {
            if (typeof siteFilterDropDownSelectID === 'string') {
                this.siteFilterDropDownSelectID = document.querySelector("[data-autosuggest-id='" + siteFilterDropDownSelectID + "']");
            } else {
                this.siteFilterDropDownSelectID = siteFilterDropDownSelectID;
            }
            if (this.siteFilterDropDownSelectID) {
                this.siteFilterDropDownSelectID.addEventListener('change', bind(this, this.filterSuggestions), false);
            }
        } else {
            this.siteFilterDropDownSelectID = false;
        }

        //event Listeners
        if (this.searchInputControlId) {

            this.searchInputControlId.addEventListener('keydown', bind(this, this.interceptKeys), false);
            this.searchInputControlId.addEventListener('input', debounce(bind(this, this.evaluateTerms), 250), false);

            // the blur event is implemented inconsistently across browsers, jquery to polyfill blur event with focusout event.
            $(this.searchInputControlId).on('blur', bind(this, this.hideResultsList));
            $(this.searchInputControlId).on('focus', bind(this, this.showResultsList));

        }

        // Applied here rather than by the caller so no instantiation path can create a widget without its ARIA contract.
        setAriaAttributes(this.searchInputControlId, this.autoCompleteResultsControlId);
    }
    
    AutoCompleteWidget.prototype = {
        solrUrl: solrUrl,
        baseURL: siteRootUrl,
        inputTerms: false,
        termsArray: false,
        baseTerms: false,
        terms: false,
        results: [],
        selectedResult: -1,
        contentID: false,
        lastAjaxRequest: false,
        lookupCache: {},
        enableEnhancedAutoSuggest: false
    };

    AutoCompleteWidget.prototype.filterSuggestions = function () {
        this.selectedResult = -1; // Reset location in drop down list

        // If we have something typed in, go ahead and get suggestions
        if (this.inputTerms.length >= minCharsRequiredForAutoSuggest) {
            this.getSuggestions();
        }
    };


    AutoCompleteWidget.prototype.evaluateTerms = function () {
        this.resetSelection();
        this.inputTerms = this.searchInputControlId.value.toLowerCase();

        $(document).trigger('searchautocomplete:input', [this.inputTerms]); // consumed by GTM datalayer events

        // No search terms. Clear autosuggest / autocomplete out.
        if (this.inputTerms.length === 0) {
            this.lastAjaxRequest = undefined; // If the user clears their input, then let them try a new search
            this.resetAutoComplete();
            return;
        }

        if (this.inputTerms.length >= minCharsRequiredForAutoSuggest) {
            if (this.lastAjaxRequest && this.lastAjaxRequest.readyState !== 4 && this.lastAjaxRequest.abort) {
                this.lastAjaxRequest.abort();
                this.lastAjaxRequest = undefined;
            }
            this.getSuggestions();
        }

        if ((this.terms && this.terms.length <= 1) || this.searchInputControlId.value !== this.inputTerms) {
            this.clearHint();
        }

    };

    AutoCompleteWidget.prototype.getJournalURL = function (journalDisplayName, searchSourceType, persistentSearchParams) {
        return 'f_JournalDisplayName=' + encodeURIComponent(journalDisplayName.trim()) + searchSourceType +
            (persistentSearchParams ? '&' + persistentSearchParams : '');
    };

    AutoCompleteWidget.prototype.getLearningURL = function (searchSourceType, persistentSearchParams) {
        if (persistentSearchParams) {
            return persistentSearchParams + searchSourceType;
        } else {
            return 'hd=learning' + searchSourceType + '&f_HasCME=true';
        }
    };

    AutoCompleteWidget.prototype.getSearchParams = function () {
        var searchSourceType = '&SearchSourceType=24'; // SOLRAutoSuggest
        var journalSearchCookieKey = 'persistentSearchFilters';
        var learningSearchCookieKey = 'persistentLearningSearchFilters';
        var journalDisplayNamePattern = /(([?|&]{1})?f_JournalDisplayName[^&]*([&]{1})?)/;
        var allJournalsPattern = /(([?|&]{1})?allJournals[^&]*([&]{1})?)/;
        var cookieKey = '';
        var cookieValue = '';
        var persistentSearchParams = '';
        var returnUrl = '';

        var siteId = this.getSiteId();

        if (siteId)
            returnUrl = (returnUrl.length ? '&' : '') + 'fl_SiteID=' + siteId;

        if (this.siteFilterDropDownSelectID) {
            return returnUrl;
        }

        return 'allJournals=1' + searchSourceType;
    };

    AutoCompleteWidget.prototype.getSiteId = function () {
        var siteId = 0;

        // From site filter
        if (this.siteFilterDropDownSelectID) {
            siteId = parseInt($(this.siteFilterDropDownSelectID).children('option:selected').data('siteid'));
        }

        return siteId;
    };

    AutoCompleteWidget.prototype.lookupFromCache = function (input) {
        var self = this;

        if (self.lookupCache[input]) {
            return self.lookupCache[input];
        }

        if (inputMatchesFailedLookup(input)) {
            self.lookupCache[input] = [];
            return [];
        }

        return null;

        function inputMatchesFailedLookup(input) {
            var cacheKeys = Object.getOwnPropertyNames(self.lookupCache);
            for (var i = 0; i < cacheKeys.length; i++) {
                var cacheKey = cacheKeys[i];
                var cachedVal = self.lookupCache[cacheKey];
                if (input.indexOf(cacheKey) === 0 && (!cachedVal || !cachedVal.length)) {
                    return true;
                }
            }
            return false;
        }
    };

    AutoCompleteWidget.prototype.getSuggestions = function () {
        var self = this;

        var cachedLookup = self.lookupFromCache(self.inputTerms);
        if (cachedLookup) {
            if (cachedLookup.length) {
                this.formatSuggestions(cachedLookup);
            } else {
                self.resetAutoComplete();
            }
            return;
        }

        var siteId = self.getSiteId();
        //todo drop self.contentID

        this.lastAjaxRequest = $.ajax({
            url: self.solrUrl,
            data: siteId ? {
                searchTerm: self.inputTerms,
                siteID: siteId
            } : {
                searchTerm: self.inputTerms
            },
            success: function (data) {
                var suggestionData = self.parseSuggestionData(data);
                if (suggestionData && suggestionData.length) {
                    self.lookupCache[self.inputTerms] = suggestionData;
                    self.formatSuggestions(suggestionData);
                }
                else {
                    self.lookupCache[self.inputTerms] = [];
                    self.resetAutoComplete();
                }
            },
            error: function () {
                self.lastAjaxRequest = undefined;
            },
            cache: true
        });
    };

    AutoCompleteWidget.prototype.parseSuggestionData = function (solrSuggestion) {

        if (!solrSuggestion)
            return [];

        var suggestionData = [];

        for (var i = 0; i < ns.autoSuggestFields.length; i++) {
            var autoSuggestField = ns.autoSuggestFields[i];
            var fieldSuggestions = solrSuggestion[autoSuggestField];

            if (fieldSuggestions && fieldSuggestions.length) {
                for (var j = 0; j < fieldSuggestions.length; j++) {
                    var fieldSuggestion = fieldSuggestions[j];
                    // skip duplicates when there are multiple fields. The values are all supposed to be lower case.
                    if (i === 0 || !suggestionData.some(function (d) { return d.Key === fieldSuggestion.Key; })) {
                        suggestionData.push({ Key: autoSuggestField, Value: fieldSuggestion });
                    }
                }
            }

        }

        if (suggestionData.length > 1) {
            suggestionData.sort(function (a, b) {
                if (a.Key === b.Key) {
                    return 0;
                }
                if (a.Key < b.Key) {
                    return -1;
                }
                return 1;
            });

            var maxNumberOfSuggestions = $('.hfAutoCompleteMaxResults').val();
            if (maxNumberOfSuggestions) {
                suggestionData = suggestionData.slice(0, maxNumberOfSuggestions * ns.autoSuggestFields.length);
            }
        }

        return suggestionData;
    };

    AutoCompleteWidget.prototype.addAutoSuggestions = function (suggestions) {
        var $selectedOption;
        var $placeholderOption = $('.cs-placeholder').text();
        var journalSearchUrl = '/search-results?q=';
        var learningSearchUrl = '/learning/searchresults?q=';
        var resultUrl = '';
        var searchFilterUrl = $(this.siteFilterDropDownSelectID).find('option:selected').val();
        var removeBaseQuery = '';
        var appendUrl = '';

        var addAuthorTitle = true;
        var addKeywordTitle = true;
        var addTaxTitle = true;

        for (var index = 0; index < suggestions.length; index += 1) {
            var suggestion = suggestions[index];
            if (this.enableEnhancedAutoSuggest === 'true') {
                if (ns.autoSuggestFields.length > 1 && suggestion.Key.indexOf('Auth') >= 0) {
                    appendUrl = '&f_' + suggestion.Key + '=' + suggestion.Value.Key;
                    removeBaseQuery = '&q=' + suggestion.Value.Key;
                    if (addAuthorTitle) {
                        var res = {
                            value: "<b>Authors</b>",
                            url: '',
                            position: 'sr' + this.autoCompleteResultsControlId.id + (index + 1)
                        };
                        this.results.push(res);
                        addAuthorTitle = false;
                    }
                }
                if (ns.autoSuggestFields.length > 1 && suggestion.Key.indexOf('Key') >= 0) {
                    appendUrl = '';
                    if (addKeywordTitle) {
                        var res = {
                            value: "<b>Keywords</b>",
                            url: '',
                            position: 'sr' + this.autoCompleteResultsControlId.id + (index + 1)
                        };
                        this.results.push(res);
                        addKeywordTitle = false;
                    }
                }
                if (ns.autoSuggestFields.length > 1 && suggestion.Key.indexOf('Tags') >= 0) {
                    appendUrl = '&exPrm_fq=' + suggestion.Key + ':%22' + suggestion.Value.Key + '%22';
                    removeBaseQuery = '&q=' + suggestion.Value.Key;
                    if (addTaxTitle) {
                        var res = {
                            value: "<b>Topics</b>",
                            url: '',
                            position: 'sr' + this.autoCompleteResultsControlId.id + (index + 1)
                        };
                        this.results.push(res);
                        addTaxTitle = false;
                    }
                }
            }

            //if searchFilterUrl is not null or empty
            if (searchFilterUrl) {
                var result = {
                    value: suggestion.Value.Key,
                    url: searchFilterUrl.replace('{searchQuery}', suggestion.Value.Key).replace(removeBaseQuery, '') + appendUrl,
                    position: 'sr' + this.autoCompleteResultsControlId.id + (index + 1)
                };
                this.results.push(result);
            }
            //fallback URL if search scope filter is disabled
            else {
                var suggestedUrl = this.baseURL;

                if ($selectedOption === learningText || $selectedOption !== $placeholderOption && $placeholderOption === learningText) {
                    resultUrl = learningSearchUrl;
                } else {
                    resultUrl = journalSearchUrl;
                }

                var searchParams = this.getSearchParams();

                var result = {
                    value: suggestion.Value.Key,
                    url: suggestedUrl + resultUrl + encodeURIComponent(suggestion.Value.Key) + (searchParams.length ? '&' + searchParams : ''),
                    position: 'sr' + this.autoCompleteResultsControlId.id + (index + 1)
                };

                this.results.push(result);
            }
        }
    };

    AutoCompleteWidget.prototype.updateSuggestions = function (suggestions) {
        this.enableEnhancedAutoSuggest = $('.hfEnableEnhancedAutoSuggest').val().toLowerCase();

        // Check to see if the user's input changed since we did auto-suggest, and if so, see if it is still relevant
        if (this.inputTerms && suggestions[0].Value.Key.indexOf(this.inputTerms) !== -1) {
            this.addAutoSuggestions(suggestions);

            this.setHint(suggestions[0].Value.Key);
            this.appendResults();
        } else {
            // If we are here, the user's input is different such that the suggestion is now invalid
            if (!this.inputTerms) {
                this.getSuggestions();
            }
        }
    }

    AutoCompleteWidget.prototype.formatSuggestions = function (suggestionData) {
        var suggestions = suggestionData;
        this.results = [];
        
        if (this.siteFilterDropDownSelectID) {
            $selectedOption = $('#' + this.siteFilterDropDownSelectID.id + ' option:selected').text();
        }
        
        if (suggestions.length) {
            this.updateSuggestions(suggestions);
        }
        else {
            this.resetAutoComplete();
        }
    };
    AutoCompleteWidget.prototype.setHint = function (h) {
        if (this.searchInputControlId.value === this.inputTerms) {
            this.searchInputHintControlId.value = h;
        }
    };
    AutoCompleteWidget.prototype.clearHint = function () {
        this.searchInputHintControlId.value = '';
    };
    AutoCompleteWidget.prototype.appendResults = function () {
        var listItems = '';
        var optionCount = 0;

        if (this.autoCompleteResultsControlId.className !== 'term-list') {
            this.autoCompleteResultsControlId.className = 'term-list';
        }

        for (var i = 0; i < this.results.length; i++) {
            var result = this.results[i];

            if (this.enableEnhancedAutoSuggest === 'true' && result.url.length === 0) {
                listItems += '<li class="suggestion-heading" role="presentation">'
                    + result.value + '</li>';
            } else {
                // Dual-id: <li id="{pos}-opt"> for aria-activedescendant,
                // <a id="{pos}"> for .active class (matches a.active CSS)
                listItems += '<li class="suggestion-result" role="option" id="'
                    + result.position + '-opt">'
                    + '<a href="' + result.url + '" id="' + result.position + '">'
                    + result.value + '</a></li>';
                optionCount++;
            }
        }
        this.autoCompleteResultsControlId.innerHTML = listItems;

        this.searchInputControlId.setAttribute('aria-expanded', 'true');

        var liveRegion = document.getElementById(LIVE_REGION_ID);
        if (liveRegion) {
            liveRegion.textContent = optionCount + ' suggestion' + (optionCount !== 1 ? 's' : '') + ' available';
        }

        var suggestionTexts = [];
        $(this.autoCompleteResultsControlId).find('.suggestion-result a').each(function () {
            suggestionTexts.push($(this).text());
        });
        if (suggestionTexts.length) {
            $(document).trigger('searchautocomplete:suggestions', [suggestionTexts]); // consumed by GTM datalayer events
        }
    };

    AutoCompleteWidget.prototype.hideResultsList = function () {
        var self = this;
        setTimeout(function () {
            self.autoCompleteResultsControlId.className = 'term-list term-list--hidden hidden hide';
            self.searchInputControlId.setAttribute('aria-expanded', 'false');
            clearActiveDescendant(self.searchInputControlId);
        }, 200);
    };
    AutoCompleteWidget.prototype.showResultsList = function () {
        this.autoCompleteResultsControlId.className = 'term-list';
        if (this.autoCompleteResultsControlId.innerHTML.length > 0) {
            this.searchInputControlId.setAttribute('aria-expanded', 'true');
        }
    };

    AutoCompleteWidget.prototype.resetResultsList = function () {
        this.autoCompleteResultsControlId.innerHTML = '';
        this.hideResultsList();
    };

    AutoCompleteWidget.prototype.resetSelection = function () {
        var oldResultId = this.selectedResult !== -1 ? this.results[this.selectedResult].position : false;

        if (oldResultId) {
            $('#' + oldResultId).removeClass('active');
        }
        this.selectedResult = -1;
        clearActiveDescendant(this.searchInputControlId);
        updateAriaSelected(this.autoCompleteResultsControlId, '');
    };

    AutoCompleteWidget.prototype.resetAutoComplete = function () {
        this.results = [];
        this.resetResultsList();
        this.clearHint();
        clearActiveDescendant(this.searchInputControlId);
        this.searchInputControlId.setAttribute('aria-expanded', 'false');
    };

    /**
     * @returns {bool} true if a term was completed; false otherwise
     */
    AutoCompleteWidget.prototype.completeTerms = function () {
        var start = this.searchInputControlId.selectionStart,
            end = this.searchInputControlId.selectionEnd,
            cursorAtEnd = start === end && end === this.inputTerms.length;

        if (cursorAtEnd && this.results && this.results.length) {
            this.searchInputControlId.value = this.results[this.selectedResult].value;
            this.evaluateTerms();
            return true;
        }
        return false;
    };

    AutoCompleteWidget.prototype.navigateResults = function (move) {
        var newSelection = this.selectedResult + move;
        oldResultId = this.selectedResult !== -1 ? this.results[this.selectedResult].position : false;
        var newResultId;
        if (newSelection < this.results.length && newSelection > -1) {
            newResultId = this.results[newSelection].position;
            oldResultId ? $('#' + oldResultId).removeClass('active') : false;
            $('#' + newResultId).addClass('active');

            this.selectedResult += move;
        }
        else {
            if (!oldResultId && this.results.length) { // Allow user to cycle through suggestions going up
                newResultId = this.results[this.results.length - 1].position;
                $('#' + newResultId).addClass('active');
                this.selectedResult = this.results.length - 1;
            } else {
                this.resetSelection();
            }
        }

        var activeOptId = this.selectedResult >= 0 && this.selectedResult < this.results.length
            ? this.results[this.selectedResult].position + '-opt' : '';
        setActiveDescendant(this.searchInputControlId, activeOptId);
        updateAriaSelected(this.autoCompleteResultsControlId, activeOptId);
    };

    AutoCompleteWidget.prototype.keyFunctions = function (e, key) {

        if (key === "ArrowRight") {
            if (this.completeTerms()) {
                e.preventDefault();
            }
        }

        if (key === "ArrowUp") {
            e.preventDefault();
            this.navigateResults(-1);
        }

        if (key === "ArrowDown") {
            e.preventDefault();
            this.navigateResults(1);
        }

        if (key === "Enter") {
            this.activateCurrentResult(e);
        }

        if (key === "Escape") {
            this.hideResultsList();
        }
    };

    AutoCompleteWidget.prototype.activateCurrentResult = function (e) {
        if (this.selectedResult <= -1) {
            return;
        }

        e.preventDefault();
        var $activeSuggestion = $(this.autoCompleteResultsControlId).find('.active');

        if (!$activeSuggestion.length) {
            return;
        }

        if (this.searchInputControlId && this.searchInputControlId.value) {
            this.searchInputControlId.value = $activeSuggestion.text();
            this.searchInputHintControlId.value = $activeSuggestion.text();
            $(document).trigger('searchautocomplete:select', [this.searchInputControlId.value]); // consumed by GTM datalayer events
            this.hideResultsList();
            var $searchSubmitButton = $(this.searchInputControlId).closest('form').find('.microsite-search-icon');
            if ($searchSubmitButton.length === 1) {
                $searchSubmitButton.trigger('click');
                return;
            }
        }

        var url = $activeSuggestion.attr('href');
        window.location = url;
    }

    AutoCompleteWidget.prototype.interceptKeys = function (e) {
        var userInput = this.searchInputControlId.value.toLowerCase();

        // Check user's current input to see if they have already reached the limit
        // If so, don't bother doing anything.
        if (userInput.length <= 255) {
            this.keyFunctions(e, e.key);
        }
    };

    ns.init = function (autoSuggestFields) {
        ns.autoSuggestFields = autoSuggestFields;
        createLiveRegion();

        var $searchTermInputs = $('.search-term-autosuggest');

        /* A page could have multiple search term inputs, e.g. desktop Vs mobile. Home page may have another input. They all should be formatted like:
        <input id="{searchTermId}" class="... search-term-autosuggest" data-autosuggest-hint="{hintId}" data-autosuggest-results="{resultsId}" /> ....
        <input id="{hintId}" class="hidden..." />
        <ul id="{resultId}"></ul>

        All search term inputs can share the same settings, e.g.:
        <input type="hidden" name="hfSolrAutoSuggestMinimumCharactersLength" class="hfSolrAutoSuggestMinimumCharactersLength" value="2">
        */
        $searchTermInputs.each(function () {
            var $searchTerm = $(this);

            var searchTermId = $searchTerm.data('autosuggest-id');
            var hintId = $searchTerm.data('autosuggest-hint');
            var resultsId = $searchTerm.data('autosuggest-results');
            var searchFilterId = $searchTerm.data('searchfilter');

            new AutoCompleteWidget(searchTermId, hintId, resultsId, false, searchFilterId);
        });
    };

    ns.AutoCompleteWidget = AutoCompleteWidget;
    ns.createLiveRegion = createLiveRegion;
    ns.setAriaAttributes = setAriaAttributes;
})(App.SearchAutoComplete = App.SearchAutoComplete || {}, SCM.JSUtility, jQuery);